<template>
  <div>
    <v-icon color="amber accent-4" @click="mostrarModal = true"
      >mdi-pencil</v-icon
    >
    <v-dialog v-model="mostrarModal" transition="dialog-bottom-transition" fullscreen persistent :disabled="infoRequisicion.ESTATUS == 'T'">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="mostrarModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Requisicion</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn dark text @click="mostrarModal = false"> Salir </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <div class="d-block  mt-3">
            <span class="text-h5 mx-3">Información.</span>
          <div class="d-flex">
            <v-btn class="mx-3 red darken-1" dark small text @click="editar = !editar">
              Editar.
            </v-btn>
            <v-btn class="mx-3 red darken-1" dark small text @click="generarPDF">
              generarPDF.
            </v-btn>
          </div>
        </div>

        <v-card class="ma-3 allB" :disabled="editar">
          <v-row style="margin: 0px !important">
            <v-col cols="12" sm="12" md="12">
              <v-card-text>
                <v-row class="ma-0 pa-0">

                <v-col cols="12" sm="12" md="2">
                  <v-text-field label="Folio" v-model="infoRequisicion.FOLIO" filled dense prepend-icon="mdi-information-variant" readonly/>
                </v-col>
                <v-col cols="12" sm="12" md="2" class="d-flex" v-if="proyectos && proyectos != 'N/A'">
                  <v-text-field label="Folio Proyecto" v-model="proyectos" filled dense prepend-icon="mdi-information-variant" readonly/>
                </v-col>
                <v-col v-else cols="12" sm="12" md="4">
                  <v-autocomplete class="mx-1" label="Asignar Proyecto" v-model="proyectoSeleccionado" :items="arregloProyectos" :item-text="getTexto" 
                  item-value="PROYECTO_ID" itemid="PROYECTO_ID" filled />
                </v-col>
                  <!-- SECCION FECHA -->
                <v-col cols="12" sm="12" md="2">
                  <v-menu v-model="modalFecha" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                    offset-y min-width="auto" :disabled="editar">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="fechaSeleccionada" label="Fecha a entregar" prepend-icon="mdi-calendar"
                        filled light readonly v-bind="attrs" v-on="on">
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="fechaSeleccionada"
                      @input="modalFecha = false" :min="minFecha[0]">
                    </v-date-picker>
                  </v-menu>
                </v-col>
                  <!-- FIN SECCION FECHA -->

                <v-col cols="12" sm="12" :md=" proyectos && proyectos != 'N/A'? 6 : 4" >
                  <v-autocomplete class="mx-1" label="Proveedor:" v-model="provRequisicionSeleccionado" :items="proveedores" item-text="NOMBRE" 
                  item-value="PROVEEDOR_ID" itemid="PROVEEDOR_ID" filled />
                  <!-- <v-text-field label="Proveedor" filled readonly :value="infoRequisicion.PRNOMBRE" class="mx-3"/> -->
                </v-col>

                </v-row>

                  <v-textarea v-model="descripcion" label="Descripcion" maxlength="50" outlined counter />

                  <!-- INFORMACION ARTICULOS DE LA REQUISICION -->
                  <div class="allB ma-1 pa-1">
                    <v-card-title>Articulos</v-card-title>
                    <div class="d-flex">
                      <v-row class="mb-2">

                      
                      <v-col cols="12" sm="12" md="4">
                        <v-text-field
                          v-model="buscador3"
                          label="Buscar"
                          append-icon="mdi-magnify"
                          class="mx-1"
                          single-line
                          hide-details
                        />
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <div class="tamTexto mx-auto d-flex align-end" style="width:fit-content">
                          <span class="noBreak">Descuento pronto pago: </span>
                          <v-text-field v-model="descuentoPP" @input="getTotal"
                          type="number" step="1.0" min="0" single-line hide-details class="mx-2 inputDescuento"/> 
                          <!-- <span class="noBreak"> en: </span>
                          <v-combobox :items="descuentos" v-model="descuento" 
                          item-text="nombre" item-value="nombre" @input="getTotal"
                          single-line hide-details class="mx-2"/> -->
                        </div>
                      </v-col>

                      <v-spacer></v-spacer>

                      <v-autocomplete label="Asignar a proveedor:" 
                      class="mx-4 align-center"
                      v-model="proveedorSeleccionado"
                      :items="proveedores" 
                      item-text="NOMBRE"
                      item-value="NOMBRE"
                      return-object
                      hide-details
                      single-line
                      @change="dividirArticulos"/>

                      </v-row>
                    </div>
                    <v-data-table
                    v-model="articulosProveedor"
                    :items="articulosOriginales"
                    :headers="columnas3"
                    :search="buscador3"
                    :disable-filtering="editar"
                    :disable-sort="editar"
                    :items-per-page="5"
                    :show-select="dividirArt"
                    item-key="ARTICULO_ID"
                    class="tamTexto grey lighten-3"
                    >
                    <template v-slot:[`header.data-table-select`]></template>
                    <template v-slot:[`item.AccionSeparar`] = "{ item }">
                      <div v-if="ajustarItem(item)">
                        <v-text-field
                          v-model="item.CANTIDADRESTA"
                          label="Cantidad"
                          type="number"
                          min="1"
                          :max="item.CANTIDADMAXIMA"
                        />
                      </div>
                      <div v-else>
                        Selecciona
                      </div>
                    </template>

                    <template v-slot:[`item.AccionQuitar`]="{ item }">
                      <v-btn
                      @click="EliminarArticuloReq(item)"
                      small
                      text
                      dark
                      class="red darken-1"
                      >
                        Eliminar
                      </v-btn>
                    </template>

                    <template v-slot:[`item.OBSERVACIONES`]="{ item }">
                      <v-textarea v-model="item.OBSERVACIONES" rows="1" auto-grow/>
                    </template>

                    <template v-slot:[`item.CANTIDAD`]="{ item }">
                      <v-text-field v-model="item.CANTIDAD"
                        label="" 
                        type="number" 
                        min="1"
                        hide-details
                        dense
                        single-line
                        @input="calcularTotales(item)"
                        />
                    </template>

                    <template v-slot:[`item.Precio`]="{ item }">
                      <v-text-field
                        v-model.number="item.PRECIO"
                        label=""
                        type="number"
                        min="0"
                        prefix="$"
                        dense
                        hide-details
                        single-line
                        @input="calcularTotales(item)"
                      />
                     </template>

                    <template v-slot:[`item.AccionCantidadDescuento1`]="{ item }">
                      <v-text-field
                        v-model="item.DESCUENTO1"
                        type="number"
                        :max="item.MAXIMO"
                        min="0"
                        dense
                        hide-details
                        single-line
                        @input="calcularTotales(item)"
                      />
                      </template>

                      <template v-slot:[`item.AccionCantidadDescuento2`]="{ item }">
                      <v-text-field
                        v-model="item.DESCUENTO2"
                        type="number"
                        :max="item.MAXIMO"
                        min="0"
                        dense
                        hide-details
                        single-line
                        @input="calcularTotales(item)"
                      />
                      </template>

                      <template v-slot:[`item.AccionDescuento`]="{ item }" @click="calcularTotales(item)">
                      <v-autocomplete
                        v-model="item.TIPODESCUENTO"
                        label="Tipo"
                        :items="descuentos"
                        item-text="nombre"
                        item-value="nombre"
                        dense
                        hide-details
                        single-line
                        @input="calcularTotales(item)"
                      />
                      </template>

                      <template v-slot:[`item.AccionImporte`]="{ item }" @click.left="calcularTotales(item)">
                        <v-text-field v-model="item.TOTAL" prefix="$" class="font-weight-regular"  readonly/>
                      </template>

                      <template v-slot:footer>
                        <div class="d-flex justify-end ml-auto align-center" style="width:50%;">
                          <span class="mx-2">Subtotal: </span>
                          <v-text-field :value="'$'+total.toFixed(2)" class="font-weight-regular" style="max-width:fit-content;" readonly/>
                        </div>
                      </template>
                    </v-data-table>
                  </div>

                <div class="d-flex justify-center">
                  <v-btn
                  class="success darken-1"
                  small
                  text
                  v-if="mostrarArticulos != true && dividirArt==false"
                  @click="mostrarArticulos = true"
                  >
                    Agregar Articulos
                  </v-btn>
                </div>
              </v-card-text>
              <v-divider></v-divider>
            <!-- <v-btn @click="LOG" color="success"> LOG</v-btn> -->
            </v-col>

            <!-- PRIMERA TABLA ARTICULOS -->
            <v-col cols="12" sm="12" md="12" v-if="mostrarArticulos" class="allB">
              <div class="d-flex">
                <v-card-title>Agregar Articulos</v-card-title>
                <v-btn
                  class="red lighten-2 mt-5 mx-3"
                  dark
                  text
                  small
                  v-if="(mostrarArticulos = true)"
                  @click="mostrarArticulos = false"
                  >Cerrar
                </v-btn>
              </div>
              <v-text-field
                v-model="buscador"
                append-icon="mdi-magnify"
                label="Buscar clave"
                single-line
                hide-details
              />
              <v-data-table
                class="pa-0 tamTexto grey lighten-3"
                :items="articulos"
                :headers="columnas"
                :search="buscador"
                :loading="cargandoArt"
                :disable-filtering="editar"
                :disable-sort="editar"
                :items-per-page="5"
                item-key="ARTICULO_ID"
              >
                <template v-slot:[`item.AccionAgregar`]="{ item }">
                  <v-btn
                    @click="AgregarArticulo(item)"
                    small
                    light
                    class="amber lighten-2"
                    style=""
                  >
                    Agregar
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
            <!-- FIN PRIMERA TABLA ARTICULOS -->
            <v-divider
              vertical
              style="border-color: rgba(0, 0, 0, 0.42)"
            ></v-divider>
            <!-- SEGUNDA TABLA ARTICULOS -->
            <v-col cols="12" sm="12" md="12" v-if="mostrarArticulos" >
              <v-card-title>Articulos En Requisicion</v-card-title>
              <v-text-field
                v-model="buscador2"
                append-icon="mdi-magnify"
                label="Buscar clave"
                single-line
                hide-details
              />
              <v-data-table
                class="pa-0 allB tamTexto grey lighten-3"
                :items="articulosAgregados"
                :headers="columnas2"
                :search="buscador2"
                :loading="cargando"
                :disable-filtering="editar"
                :disable-sort="editar"
                :items-per-page="5"
                item-key="ARTICULO_ID"
              >
                <template v-slot:[`item.AccionCantidad`]="{ item }">
                  <v-text-field
                    v-model="item.CANTIDAD"
                    label="Cantidad"
                    type="number"
                    min="1"
                    hide-details
                    dense
                    single-line
                    @input="getTotal"
                  />
                </template>
                <template v-slot:[`item.AccionObservaciones`]="{ item }">
                  <v-textarea
                    v-model="item.OBSERVACIONES"
                    label="Observaciones"
                    dense
                    auto-grow
                    rows="1"
                    hide-details
                  />
                </template>

                <template v-slot:[`item.AccionCantidadDescuento`]="{ item }">
                  <v-text-field 
                    v-model="item.DESCUENTO1"
                    label=""
                    type="number"
                    min="0"
                    value="0.0"
                    dense
                    hide-details
                    single-line
                    @input="getTotal"
                  />
                </template>

                <template v-slot:[`item.AccionCantidadDescuento2`]="{ item }">
                  <v-text-field
                    v-model="item.DESCUENTO2"
                    type="number"
                    :max="item.MAXIMO"
                    min="0"
                    dense
                    hide-details
                    single-line
                    @input="getTotal"
                  />
                </template>

                <template v-slot:[`item.AccionDescuento`]="{ item }">
                  <v-autocomplete
                    v-model="item.TIPODESCUENTO"
                    label="Tipo"
                    item-text="nombre"
                    :items="descuentos"
                    return-object
                    dense
                    hide-details
                    single-line
                    @input="getTotal"
                  />
                  
                </template>
                <template v-slot:[`item.AccionCosto`]="{ item }">
                  <v-text-field
                    v-model="item.PRECIO"
                    label=""
                    value="0.0"
                    prefix="$"
                    type="number"
                    min="0"
                    dense
                    hide-details
                    single-line
                    @input="getTotal"
                  />
                </template>
                <template v-slot:[`item.AccionQuitar`]="{ item }">
                  <v-btn
                  @click="QuitarArticulo(item)"
                  small
                  text
                  dark
                  class="red darken-1"
                  >
                    Quitar
                  </v-btn>
                </template>
                <template slot="no-data">
                  <v-alert class="my-1" :value="true" type="info" color="orange darken-2" >
                    Los articulos agregados se mostrarán aquí.
                  </v-alert>
                </template>
              </v-data-table>
            </v-col>
            <!-- FIN SEGUNDA TABLA ARTICULOS -->
          </v-row>
          <v-divider></v-divider>
          <v-card-actions class="d-flex justify-space-around">
            <v-btn class="grey darken-1" text dark @click="mostrarModal = false"
              >Cerrar</v-btn
            >
            <v-btn
              class="primary darken-1"
              text
              @click="guardarDatos"
              :loading="cargandoBtn"
              >{{textoBoton}}</v-btn
            >
          </v-card-actions>
        </v-card>
        <!-- <v-btn @click="LOG">LOG</v-btn> -->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { jsPDF } from "jspdf";
import 'jspdf-autotable'

export default {
  props: ["infoRequisicion", "allArticulos", "allProveedores"],

  data() {
    return {
      reqID:'',
      
      mostrarModal:         false,
      mostrarArticulos:     false,

      editar:               true,
      fechaSeleccionada:    "",
      modalFecha:           false,
      minFecha:             "",
      descripcion:          "",
      proyectos:            null,
      proyectoId:           '',

      articulos:            [], // LISTA DE ARTICULOS DE BD
      articulosAgregados:   [], 
      articulosOriginales:  [],
      juegosDetalle:        [],
      articulosAux:         [],
      proveedores:          [], // LISTA DE PROVEEDORES DE BD
      arregloProyectos:     [],
      proveedorSeleccionado:"", 
      provRequisicionSeleccionado: this.infoRequisicion.PRID,
      proyectoSeleccionado: null,
      articulosProveedor:   [], // ARTICULOS A DIVIDIR A LA NUEVA REQ.
      dividirArt:           false,

      // TABLA AGREGAR ARTICULOS
      columnas: [
        { text: "CLAVE",   sortable: true,  value: "CLAVE_MSP", divider: true },
        { text: "NOMBRE",  sortable: true,  value: "NOMBRE",filterable:false, divider: true },
        { text: "ACCION",  sortable: false, value: "AccionAgregar", divider: true,},
      ],
      // TABLA ARTICULOS AGREGADOS EDITAR
      columnas2: [
        { text: "CLAVE",   sortable: true,  value: "CLAVE_MSP", divider: true, width:''},
        { text: "CANTIDAD",sortable: false, value: "AccionCantidad", divider: true, width:'8%' },
        { text: "NOMBRE",  sortable: true,  value: "NOMBRE",filterable:false, divider: true, width:'20%'},
        { text: "OBSERVACIONES", sortable: false, value: "AccionObservaciones", divider: true, width:'' },
        { text: "COSTO",  sortable: false, value: "AccionCosto", divider: true , width:''},
        { text: "DESCTO1.",  sortable: false, value: "AccionCantidadDescuento", divider: true , width:''},
        { text: "DESCTO2.",  sortable: false, value: "AccionCantidadDescuento2", divider: true , width:''},
        // { text: "EN",  sortable: false, value: "AccionDescuento", divider: true , width:''},
        { text: "ACCION",  sortable: false, value: "AccionQuitar", divider: true , width:'5%'},
      ],
      // TABLA ARTICULOS ORIGINALES
      columnas3: [
          { text: "CLAVE",   sortable: true,  value: "CLAVE_MSP",      divider: true, width:''},
          { text: "NOMBRE",  sortable: true,  value: "NOMBRE",filterable:false, divider: true, width:''},
          { text: "OBSERVACIONES",  sortable: false,  value: "OBSERVACIONES",filterable:false, divider: true, width:''},
          { text: "CANTIDAD",sortable: false, value: "CANTIDAD",       divider: true, width:'5%' },
          { text: "Precio",  sortable: false, value: "Precio", divider: true, width:"110px"},
          { text: "Descto.", sortable: false, value: "AccionCantidadDescuento1", divider: true, width:"3%"},
          { text: "Descto.", sortable: false, value: "AccionCantidadDescuento2", divider: true, width:"30px"},
          // { text: "Descuento en", sortable: false, value: "AccionDescuento", divider: true, width:"140px"},
          { text: "Importe", sortable: false, value: "AccionImporte", divider: true, width:""},
          { text: "ACCION",  sortable: false, value: "AccionQuitar",   divider: true , width:'5px'},
      ],
      buscador:     "",
      buscador2:    "",
      buscador3:    "",
      cargando:     false,
      cargandoBtn:  false,
      cargandoArt:  false,
      total:0,

      toggle:true,

      descuento:{nombre:''},
      descuentoPP:0,
      descuentos:[{nombre: 'PORCENTAJE'},{nombre: 'IMPORTE'}],
    };
  },

  computed: {
    ...mapGetters(["getURLAPI", "getFechaActual", "getUsuario"]),

    textoBoton: function () {
      if ( this.dividirArt )
        return "Crear Nueva Requisicion"
      else 
        return  "Guardar Cambios"
    },

    
    // // ---------------------------------------------------------------------------
    // getTotal: function(){
    //   return this.articulosOriginales.reduce( (total,articulo) =>{
    //     return total + articulo.TOTAL;
    //   },0)
    // },


  },

  watch: {
    articulosOriginales:{
      handler(){
        // console.log(old,valor);
        // console.log("entro a handler");
        this.getTotal();
      }, deep:true
    }
  },

  methods: {
    // ---------------------------------------------------------------------------
    async getInfoRequisicion(){
      try{

      const datosReq = (await axios.get(`${this.getURLAPI}/Requisiciones/mostrarRequisicion/${this.infoRequisicion.REQUISICION_ID}`)).data;
        // console.log(datosReq);
      this.descuentoPP = datosReq[0].DESCUENTO_PP ?? 0;
      this.reqID = datosReq[0].REQUISICION_ID;
      this.reqDescripcion = datosReq[0].DESCRIPCION;
      this.reqFecha = datosReq[0].FECHA.split(" ")[0];
       this.reqJuegoNombre = datosReq[0].JUEGONOMBRE;
       this.reqJuegoUnidad = datosReq[0].JUEGOUNIDADES;
      

      this.fechaSeleccionada = this.reqFecha;
      this.descripcion = this.reqDescripcion;
      this.juegoNombre = this.reqJuegoNombre;
      this.unidadesJuego = this.reqJuegoUnidad;
      this.getDetalle();
      // this.getArticulos();
      this.getProveedores();
      }
      catch(err){
        this.$root.vtoast.show({
              message: "Error al conectar con el servidor",
              color: "red darken-1",
              timer: 10000,
              icon: "mdi-alert-circle-outline",
            });
      }


    },

    // ---------------------------------------------------------------------------
    async getDetalle() {
      this.articulosOriginales = [];
      this.articulosOriginales = (
        await axios.get(
          `${this.getURLAPI}/Requisiciones/mostrarRequisicionDetalle/${this.infoRequisicion.REQUISICION_ID}`
        )
      ).data;

      this.articulosAux = JSON.parse(JSON.stringify(this.articulosOriginales));

      for (const articulo of this.articulosOriginales) {
        if (articulo.PRECIO == null) {
          articulo.PRECIO = 1;
        }
        articulo.CANTIDADMAXIMA = new Object(articulo.CANTIDAD);
        articulo.CANTIDADRESTA = 1
        articulo.TIPODESCUENTO = this.descuentos[0].nombre
        this.calcularTotales(articulo)

      }
      

      // console.log(this.articulosOriginales);
    },

    // ---------------------------------------------------------------------------
    getArticulos() {
      this.cargandoArt = true;
      this.articulos = this.allArticulos;
      this.articulos.forEach((articulo) => {
        articulo.CANTIDAD = 1;
        articulo.TIPODESCUENTO = this.descuentos[0].nombre;
        articulo.PRECIO = 1;
        articulo.DESCUENTO1 = 0;
        articulo.DESCUENTO2 = 0;
      });
      this.cargandoArt = false;
    },

    // ---------------------------------------------------------------------------
    async getProveedores(){
      // this.proveedores = (await axios.get(`${this.getURLAPI}/Show/allProveedores`)).data
      this.proveedores = this.allProveedores;
    },

    // ---------------------------------------------------------------------------
    AgregarArticulo(articulo) {
      if (!this.articulosAgregados.includes(articulo) || articulo.NOMBRE == 'VARIOS') {
        this.articulosAgregados.push(articulo);
        this.$emit("setArticulos", this.articulosAgregados);
        console.log(this.articulosAgregados);
        console.log(JSON.stringify(this.articulosAgregados));
      }
    },

    // ------------------------------------------------------------------------------
    QuitarArticulo(articulo) {
      articulo.ARCHIVO = "";
      const index = this.articulosAgregados.indexOf(articulo);
      if (index > -1) {
        this.articulosAgregados.splice(index, 1);
        this.$emit("setArticulos", this.articulosAgregados);
      }
      console.log(this.articulosAgregados);
    },
    
    // ---------------------------------------------------------------------------
    EliminarArticuloReq(articulo){
      let eliminar = confirm(`Eliminar el articulo ${articulo.NOMBRE}?` );

      if ( eliminar ) {
        let datosForm = new FormData();
        datosForm.append("ARTICULO_ID",     articulo.ARTICULO_ID);
        datosForm.append("ARTICULO_NOMBRE", articulo.NOMBRE);
        datosForm.append("REQUISICION_ID",  this.infoRequisicion.REQUISICION_ID);

        axios.post(`${this.getURLAPI}/Requisiciones/eliminarArticuloReq`, datosForm)
        .then( ({data}) =>{
          this.$root.vtoast.show({
              message: data.MSG || "Error",
              color: data.STATUS == "OK" ? "success darken-1" : "red darken-1",
              timer: 10000,
              icon: data.STATUS == "OK" ? "mdi-check" : "mdi-alert-circle-outline",
            });
          this.getDetalle();
        } )
        .catch( () => {
          this.$root.vtoast.show({
              message: "Hubo un error en el servidor.",
              color: "black darken-2",
              timer: 10000,
              icon: "mdi-alert-circle-outline",
            });
        })
      }
    },

    // ---------------------------------------------------------------------------
    dividirArticulos() {
      console.log(this.proveedorSeleccionado);
      if ( this.proveedorSeleccionado != null  ) {
        this.dividirArt= true;
        this.columnas3 = [
          { text: "CLAVE",   sortable: true,  value: "CLAVE_MSP",      divider: true, width:'5%'},
          { text: "NOMBRE",  sortable: true,  value: "NOMBRE",filterable:false, divider: true, width:'75%'},
          { text: "OBSERVACIONES",  sortable: true,  value: "OBSERVACIONES",filterable:false, divider: true, width:'75%'},
          { text: "CANTIDAD",sortable: false, value: "CANTIDAD",       divider: true, width:'auto' },
          { text: "SEPARAR", sortable: false, value: "AccionSeparar",       divider: true, width:'10%' },
          { text: "ACCION",  sortable: false, value: "AccionQuitar",   divider: true , width:'10%'},
        ];

        this.mostrarArticulos = false;

      }
      else{
        this.articulosProveedor = [];
        this.dividirArt= false;
        this.columnas3 = [
          { text: "CLAVE",   sortable: true,  value: "CLAVE_MSP",      divider: true, width:''},
          { text: "NOMBRE",  sortable: true,  value: "NOMBRE",filterable:false, divider: true, width:''},
          { text: "OBSERVACIONES",  sortable: true,  value: "OBSERVACIONES",filterable:false, divider: true, width:''},
          { text: "CANTIDAD",sortable: false, value: "CANTIDAD",       divider: true, width:'5%' },
          { text: "Precio",  sortable: false, value: "Precio", divider: true, width:"110px"},
          { text: "Descto.", sortable: false, value: "AccionCantidadDescuento1", divider: true, width:"3%"},
          { text: "Descto.", sortable: false, value: "AccionCantidadDescuento2", divider: true, width:"30px"},
          // { text: "Descuento en", sortable: false, value: "AccionDescuento", divider: true, width:"140px"},
          { text: "Importe", sortable: false, value: "AccionImporte", divider: true, width:""},
          { text: "ACCION",  sortable: false, value: "AccionQuitar",   divider: true , width:'5px'},
        ]
      }
    },

    // ---------------------------------------------------------------------------
    // dinero( precio ){
    //   return Intl.NumberFormat('es-MX',{
    //     style:'currency',
    //     currency: 'MXN'
    //   }).format(precio);
    // },

    // ---------------------------------------------------------------------------
    generarPDF(){
      //  DOCUMENTACION PDF - http://raw.githack.com/MrRio/jsPDF/master/docs/jsPDF.html
      let dinero = new Intl.NumberFormat('es-MX',{
        style:'currency',
        currency: 'MXN'
      });

      const doc = new jsPDF();
      console.log(doc.getFontList());

      let colsTablaRequisicion = [['REQUISICION']];
      let datosTablaRequisicion = [];
      datosTablaRequisicion.push([this.reqDescripcion.toUpperCase()]);

      if (this.proyectos && this.proyectos != 'N/A') {
        console.log("entre a proyecto");
        colsTablaRequisicion[0].push('PROYECTO');
        datosTablaRequisicion[0].push(this.proyectos)
      }
      if (this.infoRequisicion.PRNOMBRE && this.infoRequisicion.PRNOMBRE != 'N/A') {
        console.log("entre a proveedor");
        colsTablaRequisicion[0].push('PROVEEDOR');
        datosTablaRequisicion[0].push(this.infoRequisicion.PRNOMBRE)
      }

      let colsTablaFechaFolio = [['FECHA ENTREGA', 'FOLIO']];
      let datosTablaFechaFolio = []; 
      datosTablaFechaFolio.push( [this.reqFecha,this.infoRequisicion.FOLIO] )

      // let colsTablaJuegoKit = [['CLAVE', 'NOMBRE ARTICULOS DEL KIT', 'UNIDADES']];
      // let datosTablaJuegoKit = [];
      // datosTablaJuegoKit.push([this.infoRequisicion.CLAVE_MSP, this.reqJuegoNombre, this.reqJuegoUnidad])

      let colsTablaTotales = [['DESCUENTO PP','SUBTOTAL']]
      let datosTablaTotales = [];
      datosTablaTotales.push( [`${this.descuentoPP}`, dinero.format(this.total)] )

     
      
      // for (const articulo of this.articulosOriginales) {
      //   totalCantidad += parseInt( articulo.CANTIDAD );
      // }

      let imagen = new Image();
      imagen.src = require('../../../assets/BySN.jpg');
      // imagen.src = '../../../assets/BySN.jpg';
      // doc.addImage(imagen.src,'JPG', 5,-8,50,50)
      // MARGEN y COORDENADAS
      /*let x = 10;*/ let y = 10;
      let ancho = doc.internal.pageSize.getWidth(); 
      let alto = doc.internal.pageSize.getHeight();
      // doc.rect(5, 5, ancho - x, alto - y) 

      // doc.setFont('helvetica','bold');
      // doc.setTextColor(28,44,230);
      // doc.setFontSize(17);
      // // doc.text("BOMBAS Y SUMINISTROS DEL NORTE. SA. de C.V.", ancho/2, y+3, null, null, 'center');
      // doc.text("REQUISICION DE COMPRA", ancho/2, y+10, null, null, 'center');
      y += 20;

      // TABLA ARTICULOS
      let colsTablaArticulos = [['CLAVE', 'CANTIDAD', 'NOMBRE', 'DESCRIPCION','PRECIO','DESCUENTO','DESCUENTO','IMPORTE']];
      let datosTablaArticulos = [];
      //let datosTablaJuego =[];

      if(datosTablaArticulos)
      console.log("entro a la info de articulos");
      for (let articulo of this.articulosOriginales) 
      {
        datosTablaArticulos.push( [
          articulo.CLAVE_MSP, articulo.CANTIDAD, articulo.NOMBRE, articulo.OBSERVACIONES, 
          dinero.format(articulo.PRECIO).split('$')[1], articulo.DESCUENTO1, articulo.DESCUENTO2, dinero.format(articulo.TOTAL).split('$')[1],
          ] )

          let juegosDet = articulo.JUEGOS_MSP;
         
          if(juegosDet.length > 0)
          console.log("entro al IF DE LOS JUEGOS KIT"); 
                for(const juego of Object(juegosDet))
                {
                   datosTablaArticulos.push([
                  juego.CLAVE_ARTICULO_ID, juego.UNIDADES, juego.NOMBRE_ARTICULO,
                  //224, 255, 255
                   ])
                }
                
         
      }  
    
            
      //CREACION
      doc.autoTable({ 
        head:colsTablaArticulos,  // COLUMNAS
        body:datosTablaArticulos,// RENGLONES (DATOS =  0:CLAVE, 1:NOMBRE, 2:CANTIDAD )
        theme:'grid',
        margin:{top: 50},
        styles: {  //ESTILO GENERAL
          cellPadding:{left:2,top:2,right:2}, fontSize:7, fontStyle:'bold', lineColor:[44, 62, 80], lineWidth: .2,
        },
        headStyles: { //ESTILO DE COLUMNAS
          fillColor:[0, 112, 177], fontSize:6, valign:'middle'
        },
        columnStyles: { 
          0:{ cellWidth:'wrap',valign:'bottom'}, 
          1:{ cellWidth:'wrap',halign:'right',valign:'bottom',fillColor:[240,248,255], fontStyle:'italic' }, 
          2:{ halign: 'left',fillColor:[240,248,255], fontStyle:'italic', textColor: 'black'}, 
          3:{ valign:'bottom' }, 
          4:{ cellWidth:'wrap',halign:'right',valign:'bottom' }, 
          5:{ cellWidth:'wrap',halign:'right',valign:'bottom' }, 
          6:{ cellWidth:'wrap',halign:'right',valign:'bottom' }, 
          7:{ cellWidth:'wrap',halign:'right',valign:'bottom' }, 
        },
        didDrawPage:function(){
          //ENCABEZADO
          doc.addImage(imagen.src,'JPG', 5,-8,50,50)
          // MARGEN y COORDENADAS
          // let x = 10; let y = 10;
          // let ancho = doc.internal.pageSize.getWidth(); 
          // let alto = doc.internal.pageSize.getHeight();
          doc.rect(5, 5, ancho - 10, alto - 10) 
    
          doc.setFont('helvetica','bold');
          doc.setTextColor(0, 112, 177);
          doc.setFontSize(17);
          // doc.text("BOMBAS Y SUMINISTROS DEL NORTE. SA. de C.V.", ancho/2, y+3, null, null, 'center');
          doc.text("REQUISICION DE COMPRA", ancho/2, 20, null, null, 'center');

          doc.autoTable({
          head: colsTablaRequisicion,
          body: datosTablaRequisicion, // RENGLONES (DATOS =  0:REQUISICION )
          // startY: y+5,
          headStyles: { //ESTILO DE COLUMNAS
            fillColor:[0, 112, 177], fontSize:7, halign:'center'
          },
          styles: { /*overflow: 'hidden',*/ fontSize:7, fontStyle:'bold', lineColor: [44, 62, 80], lineWidth: .2, valign:'bottom', halign:'center'},
          margin: { top:30, right: 107 },
        })

        //----------------------------------DISEÑO DEL TEXTO
          
      
        //----------------------------------------------------
          // TABLA FECHA / FOLIO
          doc.autoTable({ 
            head: colsTablaFechaFolio,
            body: datosTablaFechaFolio, // RENGLONES (DATOS =  0:FECHA, 1:FOLIO )
            startY: y,
            headStyles: { //ESTILO DE COLUMNAS
              fillColor:[0, 112, 177], fontSize:7, valign:'middle'
            },
            styles: { overflow: 'hidden', fontSize:7, fontStyle:'bold', lineColor: [44, 62, 80], lineWidth: .2, },
            margin: { bottom:30, left: 107 },
          })
        }
      });

      
       y = doc.lastAutoTable.finalY ;
        // y = alto - doc.lastAutoTable.finalY ;
        // console.log(alto,doc.lastAutoTable.finalY, ancho);
      for ( y ; y < alto - 50; y+=15 ) {
        // for (let j = 15; j < ancho-15; j+=25) {
          // doc.text("*",15,y);
          // doc.text("*",ancho/2,y);
          // doc.text("*",ancho-15,y);
        // }
      }

      // TABLA TOTALES
      doc.autoTable({
        head:   colsTablaTotales,  // COLUMNAS
        body:   datosTablaTotales, // RENGLONES (DATOS =  0:TOTAL )
        theme:  'grid',
        startY: y,
        styles: {  //ESTILO GENERAL
          cellPadding:{left:2,top:2,right:2}, fontSize:7, fontStyle:'bold', lineColor: [44, 62, 80], lineWidth: .2, 
        },
        headStyles: { //ESTILO DE COLUMNAS
          fillColor:[0, 112, 177], fontSize:7, halign: 'right', valign:'middle'
        },
        columnStyles: { 
          0: { halign: 'right' },
          1: { halign: 'right' },
        },
        margin: { left: ancho / 1.5 },
      });

      doc.save( `${this.infoRequisicion.FOLIO}_${this.getFechaActual}` );
    },

    // ---------------------------------------------------------------------------
    ajustarItem( item ){
      if(!this.articulosProveedor.includes(item)) return false;

      // item.CANTIDAD = item.CANTIDADMAXIMA;
      // item.CANTIDAD = item.CANTIDADRESTA;
      // console.log("YAMETEKUDASAI");
      return true;
    },

    // ---------------------------------------------------------------------------
    calcularTotales( item ){
      let total = Number(item.CANTIDAD * item.PRECIO);
      // console.log("entro a totales");
      if(item.TIPODESCUENTO == 'PORCENTAJE') {
      // console.log("entro a PORCENTAJE");
        // item.TOTAL = total - ((total * item.DESCUENTO1)/100 - (total * item.DESCUENTO2)/100).toFixed(2);

        // RESTAR DESCUENTO 1
        total = total - (total * item.DESCUENTO1) / 100;
        // RESTAR DESCUENTO 2
        total = total - (total * item.DESCUENTO2) / 100;
        // ASIGNAR NUEVO TOTAL AL ITEM
        item.TOTAL = total;
      }
      else if(item.TIPODESCUENTO == 'IMPORTE') {
      // console.log("entro a IMPORTE");
        item.TOTAL = total - Number(item.DESCUENTO1) - Number(item.DESCUENTO2);
      }
    },

    // ---------------------------------------------------------------------------
    getTotal(){
      this.total = 0;
      let resultado = 0;
      // let dinero = new Intl.NumberFormat('es-MX',{style:'currency',currency: 'MXN'});

      this.articulosOriginales.forEach( (articulo) =>{  
        this.calcularTotales(articulo);
        resultado += articulo.TOTAL;
      })
        // this.total = dinero.format(resultado);
        this.total = resultado;
      // console.log("s",this.descuento.nombre);
      // if (this.descuento.nombre == 'PORCENTAJE')
      //   this.total = resultado - (resultado * this.descuentoPP)/100
      // else 
      //   this.total = resultado - this.descuentoPP
    },

    // ---------------------------------------------------------------------------
    LOG(){
      // if( JSON.stringify(this.articulosAux) === JSON.stringify(this.articulosOriginales)){
        console.log(this.articulosAux, this.articulosOriginales);
      if( this.arrIdentical(this.articulosAux, this.articulosOriginales )){
        console.log("son iguales");
        return;
      }
      else{
        console.log("son iguales");
        return
      }
    },

    // ------------------------------------------------------------------------------
    getTexto(item){
      return `${item.FOLIO} | ${item.NOMBRE}`
    },

    // ------------------------------------------------------------------------------
    async getProyectos(){
      this.arregloProyectos = (await axios.get(`${this.getURLAPI}/Show/allProyect`)).data;
      // console.log(this.almacenes);
    },

    // ---------------------------------------------------------------------------
    guardarDatos() {
      if( this.dividirArt ){
        try{
        // DIVIDIR ARTICULOS PROVEEDOR
          let datosForm = new FormData();
          datosForm.append( "ARTICULOS", JSON.stringify(this.articulosProveedor) );
          datosForm.append( "PROVEEDOR", JSON.stringify(this.proveedorSeleccionado) );
          datosForm.append( "REQUISICION_ID", this.reqID );
          datosForm.append( "FOLIO", this.infoRequisicion.FOLIO );
          datosForm.append( "FECHA", this.fechaSeleccionada );
          datosForm.append( "USUARIO_CREADOR", this.getUsuario );
          if (this.proyectoId && this.proyectoId > 0) {
            datosForm.append( "PROYECTO_ID", this.infoRequisicion.PID);
          } 

          console.log(this.proveedorSeleccionado);

          axios.post(`${this.getURLAPI}/Requisiciones/dividirRequisicion`, datosForm)
          .then( ({data}) =>{
            // console.log(data);
            this.$root.vtoast.show({
              message: data.MSG || "Error",
              color: data.STATUS == "OK" ? "success darken-1" : "red darken-1",
              timer: 10000,
              icon: data.STATUS == "OK" ? "mdi-check" : "mdi-alert-circle-outline",
            });
            this.getInfoRequisicion();
            this.articulosProveedor = [];
          })
          .catch();


        }catch ( error ) {
          this.$root.vtoast.show({
            message:  "Revisa los datos.",
            color:    "red darken-1",
            timer:    10000,
            icon:     "mdi-alert-circle-outline",
          });
        }
      }
      else{
        try {
          this.cargandoBtn = true;
          let datosForm = new FormData();

          datosForm.append( "REQUISICION_ID", this.infoRequisicion.REQUISICION_ID);//23
          datosForm.append( "ESTATUS", this.infoRequisicion.ESTATUS);  //A
          datosForm.append( "FECHA", this.fechaSeleccionada);  //2022-04-01
          datosForm.append( "DESCRIPCION", this.descripcion);  //789456
          datosForm.append( "DESCUENTOPP", this.descuentoPP);  //4
          datosForm.append( "USUARIO_MODIFICACION", this.getUsuario);  //MARCO1
          datosForm.append( "ARTICULOS_ORIGINALES", JSON.stringify(this.articulosOriginales));
          datosForm.append( "PROVEEDOR_REQUISICION", this.provRequisicionSeleccionado ); 
          // console.log( JSON.stringify(this.articulosOriginales));
          if (this.articulosAgregados.length > 0) {
            datosForm.append("ARTICULOS", JSON.stringify(this.articulosAgregados));          
          }
          if (this.proyectoId && this.proyectoId > 0) {
            datosForm.append("PROYECTO_ID", this.infoRequisicion.PID);
          }
          if ( this.proyectoSeleccionado && this.proyectoSeleccionado != null ) {
            datosForm.append("ASIGNAR_PROYECTO_ID", this.proyectoSeleccionado);
          }
          for(var val of datosForm.values()){
            console.log(val);
          }
          axios
            .post(`${this.getURLAPI}/Requisiciones/editarRequisicion`, datosForm)
            .then(({ data }) => {
              console.log(data);
              this.cargandoBtn = false;
              this.$root.vtoast.show({
                message: data.MSG || "Error",
                color: data.STATUS == "OK" ? "success darken-1" : "red darken-1",
                timer: 10000,
                icon: data.STATUS == "OK" ? "mdi-check" : "mdi-alert-circle-outline",
              });
              this.articulosAgregados = [];
              this.mostrarArticulos = false;
              this.getInfoRequisicion();
            })
            .catch(() => {
              this.cargandoBtn = false;
              this.$root.vtoast.show({
                message: "Hubo un error en el servidor.",
                color: "black darken-2",
                timer: 10000,
                icon: "mdi-alert-circle-outline",
              });
            });
        } 
        catch (error) {
          this.cargandoBtn = false;
          console.log("Error");
        }
      }
    },
      
    // ---------------------------------------------------------------------------
  },

  created() {
    this.getInfoRequisicion();
    // this.getInfoProyecto()
    this.descuento.nombre = 'PORCENTAJE'
    // console.log(this.decuento);
    this.proyectos = this.infoRequisicion.PFOLIO;
    this.getArticulos();

    if ( !(this.proyectos && this.proyectos != 'N/A') ) {
      this.getProyectos();
      
    }
    // this.proyectoId = this.infoRequisicion.PROYECTO
    // this.articulos = this.allArticulos;
    // console.log(this.articulos);


  },
};
</script>

<style>
  
  #tabla td{
    font-size:inherit!important;
    /* height: 48px; */
  }

  #tabla input{
    font: 100;
  }

  div.d-flex.justify-end.ml-auto input{
    text-align: right;
  }

</style>
